module.exports = __webpack_public_path__ + "static/media/orion_small.12f09834.png";